export const $search = document.querySelector('#search-app');
export const labels = $search ? JSON.parse($search.dataset.labels) : {};
export const endpoint = $search && $search.dataset.endpoint;
export const initialFilters = $search
  && JSON.parse($search.dataset.initialFilters.replaceAll('&quot;', '"'));
export const showMaininput = $search && $search.dataset.showMaininput === 'true';
export const restrictionFilters = ($search
    && $search.dataset.restrictionFilters
    && JSON.parse($search.dataset.restrictionFilters.replaceAll('&quot;', '"')))
  || false;
export const searchType = $search && $search.dataset.searchType;
export const autoSuggest = $search ? $search.dataset.suggest : null;
export const geoCoordinates = $search ? $search.dataset.geoCoordinates : null;
export const showCount = $search && $search.dataset.showCount === 'true';
export const showFacets = $search && $search.dataset.showFacets === 'true';
export const headingLevelOne = $search && $search.dataset.headingLevelOne === 'true';
